export enum PatientErrorCodes {
	PendingPatientForbiddenAccess = "PENDING_PATIENT_FORBIDDEN_ACCESS",
}

export class PendingPatientForbiddenAccessError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}

export class PatientNotPendingError extends Error {}
